<template>
  <div class="included-content">
    <div v-if="plan.most_popular" class="most-popular">Mais popular</div>
    <div class="included-items">
      <h3>{{ title }}</h3>
      <p>{{ description }}</p>
      <div class="divider"></div>

      <div v-if="plan && !plan.price && plan?.code != 'custom'" class="stamp">
        <img :src="require('@/assets/selo-gratis-7.png')" alt="image" />
      </div>
      <div v-if="plan?.code === 'custom'" class="list">
        <Item description="Mais de 08 usuários" :planInfo="true" />
        <Item description="Mais de 280 Carros/mês" :planInfo="true" />
      </div>

      <div v-else class="list">
        <Item
          v-for="(item, i) in items"
          :description="item.description"
          :isBool="item.isBoolean"
          :planInfo="isItemAvailable(item.key)"
          :planId="plan?.id"
          :key="i.key"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Item from './Item';

export default {
  name: 'SignatureIncludedItems',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    plan: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      items: [
        { description: 'Usuários', key: 'limit_user' },
        { description: 'Serviços/mês', key: 'limit_os' },
        { description: 'Quantidade de fotos e vídeos ilimitada', key: 'limit_media', isBoolean: true },
        { description: 'anos de armazenamento em nuvem', key: 'limit_media_cloud_gb', isCountable: true },
        { description: 'Portal de agendamentos para o cliente', key: 'scheduling_portal', isBoolean: true },
        { description: 'Perfil do cliente com histórico completo', key: 'os_personalized' },
        { description: 'Identificação automática da placa pela foto', key: 'vehicle_plate_recognition' },
        { description: 'Módulo de leva e traz', key: 'module_bring' },
        { description: 'Módulo de orçamentos', key: 'module_budget' },
        { description: 'Módulo de agendamento (calendário)', key: 'module_scheduling' },
        { description: 'Módulo de assinatura eletrônica', key: 'module_digital_signature' },
        { description: 'Link do serviço personalizado via WhatsApp', key: 'os_personalized' },
        { description: 'Pesquisa de satisfação no link do serviço', key: 'os_satisfaction_survey' },
        { description: 'Banner personalizado no link do serviço', key: 'custom_os_banner' },
        { description: 'modelos de checklists personalizados', key: 'limit_checklist_model' },
        { description: 'Permite alternar entre múltiplas empresas (filiais)', key: 'multi_company_panel' },
        { description: 'Painel gestão de pátio para TV', key: 'service_panel' },
        { description: 'Extensão WhatsApp Web', key: 'whatsapp_integration' },
        { description: 'Módulo de chat interno', key: 'module_chat' },
        { description: 'Central de campanhas', key: 'module_campaigns' },
        { description: 'Central de satisfação do cliente', key: 'module_client_satisfaction' },
        { description: 'Módulo de notificações automáticas', key: 'reminders' },
        { description: 'Suporte', key: 'full_time_support' }
      ],
      alwaysIncluded: ['deployment_rate', 'full_time_support']
    };
  },
  methods: {
    isItemAvailable(key) {
      // eslint-disable-next-line no-prototype-builtins
      if (!this.plan.hasOwnProperty(key)) return false;

      if (this.alwaysIncluded.includes(key)) return true;

      return this.plan[key];
    }
  },
  components: { Item }
};
</script>

<style lang="scss">
.included-content {
  position: relative;

  .most-popular {
    position: absolute;
    right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px 4px 16px;
    background: #e2f3ed;
    border-radius: 0px 0px 12px 12px;

    color: #3a9071;
    font-size: 12px;
    font-weight: 600;
  }

  .stamp {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 9px 0 16px 0;
  }
}
.included-items {
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-top: 12px;

  h3 {
    color: #3f505f;
    font-size: 16px;
    font-weight: 600;
  }

  p {
    margin: 0;
    color: #3f505f;
    font-size: 12px;
    font-weight: 400;
  }

  .list {
    .item {
      display: flex;
      align-items: center;
      .icon {
        padding-right: 16px;
      }
      .text {
        color: #3f505f;
        font-size: 12px;
      }
    }
  }
}
</style>
